// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3ccGu","label":"Category_label__3sLNb","content":"Category_content__C4ob6","header":"Category_header__3ti5Q","location":"Category_location__3H3oj"};